export type ITextAreaCharCounter = IDCA.IGenericFunc;

export function _textAreaCharCounter(): void {
  $('textarea').each((_, area) => {
    const $area = $(area);
    if (!Number.isNaN(Number($area.attr('maxlength'))) && Number($area.attr('maxlength')) > 0) {
      const maxChars = Number($area.attr('maxlength'));
      const twntPercent = parseInt((maxChars * 0.2).toString(), 10);
      // On keyup binding
      $area.off('keyup').on('keyup', e => {
        const $charCounter = $(`#char_counter_${$(e.currentTarget).attr('name')}`);
        const $charCounterNumUsed = $charCounter.find('.num-used');
        const $charCounterNumLeft = $charCounter.find('.num-left');
        const currentCount = ($(e.currentTarget).val() as string).split('').length;
        const charsLeft = maxChars - currentCount;
        if (charsLeft < maxChars) {
          $charCounter.show();
          $charCounterNumUsed.html(`${currentCount}`);
          $charCounterNumLeft.html(`${charsLeft}`);
          if (charsLeft < twntPercent) {
            $charCounter.addClass('danger');
          } else {
            $charCounter.removeClass('danger');
          }
        } else {
          $charCounter.hide();
        }
      });
    }
  });
}
